export const headCells = [
  {
    id: "created",
    numeric: false,
    disablePadding: true,
    label: "Created",
  },
  {
    id: "name",
    numeric: true,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "phone_number",
    numeric: true,
    disablePadding: false,
    label: "Phone number",
  },
  {
    id: "wellness",
    numeric: true,
    disablePadding: false,
    label: "Wellness category",
  },
  // {
  //   id: "city",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "City",
  // },
  {
    id: "service",
    numeric: true,
    disablePadding: false,
    label: "Service chosen",
  },
  {
    id: "ivf_status",
    numeric: true,
    disablePadding: false,
    label: "Treatment Journey",
  },
 
  {
    id: "Source",
    numeric: true,
    disablePadding: false,
    label: "Source",
  }, {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "last_contacted",
    numeric: true,
    disablePadding: false,
    label: "Last Contacted",
  },
  // {
  //   id: "last_reminder",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Last Reminder",
  // },
];
export const Source = [
  { id: "whatsapp", name: "Whatsapp" },

  { id: "facebook", name: "Facebook" },
  { id: "instagram", name: "Instagram" },
  { id: "google", name: "Google" },
  { id: "walk-in", name: "Walk-In" },

  { id: "twitter", name: "Twitter" },
  { id: "linkedin", name: "Linkedin" },
  { id: "youtube", name: "Youtube" },
  { id: "flyer", name: "Flyer" },
  { id: "referral", name: "Referral" },
];
